import React from "react";
import useWinterWheelsPanel from "../../../../hooks/customize/winterwheels/useWinterWheelsPanel";
import { useBnbSelector } from "../../../../redux/store";
import { calculateWinterWheelPrice } from "../../../../utils/typedUtils";
import { BnbLabel } from "../../../../utils/labels";
import * as Styles from "./styles/WinterWheels";
import Price from "../../common/price/Price";
import ButtonTertiary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonTertiary";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { getCarDBAssetSrcSet } from "../../../../../../shared-logic/utils/imageUtils";

const WinterWheelsPanel = (): JSX.Element => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const { activeWinterWheel, cheapestWinterWheel, previewImageUrl, openModal, clearSelectedWheel } =
        useWinterWheelsPanel();

    return (
        <Styles.Wrapper>
            <Styles.WheelPreview>
                <Styles.ImageWrapper>
                    <img
                        {...getCarDBAssetSrcSet(settings, [{ width: 120, height: 120 }], previewImageUrl)}
                        loading="lazy"
                        width="60"
                        height="60"
                        sizes="60px"
                        alt=""
                        role="presentation"
                    />
                </Styles.ImageWrapper>
                <Styles.WheelHeader>
                    <Styles.Name>
                        {activeWinterWheel ? activeWinterWheel.name : <BnbLabel label="winterWheelsHeader" />}
                    </Styles.Name>
                    {activeWinterWheel ? (
                        <Styles.Price>
                            <Price
                                price={calculateWinterWheelPrice(activeWinterWheel)}
                                financeItemId={activeWinterWheel.id}
                            />
                        </Styles.Price>
                    ) : (
                        showPrice(settings) &&
                        (cheapestWinterWheel.price.cash > 0 || cheapestWinterWheel.price.monthly > 0) && (
                            <Styles.Price>
                                <Price
                                    price={calculateWinterWheelPrice(cheapestWinterWheel)}
                                    financeItemId={cheapestWinterWheel.id}
                                />
                            </Styles.Price>
                        )
                    )}
                    <Styles.OptionalText>
                        <BnbLabel label="winterWheelsOptional" />
                    </Styles.OptionalText>
                </Styles.WheelHeader>
            </Styles.WheelPreview>
            <Styles.Actions columns={activeWinterWheel ? 2 : 1}>
                <ButtonTertiary onClick={openModal}>
                    <BnbLabel label={activeWinterWheel ? "winterWheelsEditButton" : "winterWheelsChooseButton"} />
                </ButtonTertiary>
                {activeWinterWheel && (
                    <ButtonTertiary onClick={clearSelectedWheel}>
                        <BnbLabel label="winterWheelsRemoveButton" />
                    </ButtonTertiary>
                )}
            </Styles.Actions>
        </Styles.Wrapper>
    );
};

export default WinterWheelsPanel;
